function compact(value: string): string {
  return value.toLowerCase().replace(/[\s/,._-]+/g, "");
}

/** Token match for the preferences search box. Every token must appear. */
export function preferenceMatches(
  query: string,
  ...fields: Array<string | undefined | null>
): boolean {
  const tokens = query
    .toLowerCase()
    .split(/[\s/,._-]+/)
    .map((token) => token.trim())
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const haystack = fields.filter(Boolean).join(" ").toLowerCase();
  const compactHaystack = compact(haystack);
  return tokens.every(
    (token) => haystack.includes(token) || compactHaystack.includes(compact(token)),
  );
}
